import * as errorConstants from 'constants/Errors';
import * as uiLib from '@compliance.ai/web-components';
import * as env from 'shared/config';

import Bugsnag from '@bugsnag/js';

export class NetworkError extends Error {
  status: number;
  type: string;
  message: string;

  constructor({ message, type, status }: { message: string; status: number; type: string }) {
    super(message);

    this.status = status;
    this.type = type;
    this.message = message;
  }
}

/**
 * Get the error message by error type
 */
export const getErrorAlertMessage = (error: Record<string, unknown>) => {
  if (error && error.type) {
    return error.type === errorConstants.ERROR_TYPES.TIMEOUT
      ? 'Sorry, we didn’t anticipate this taking so long! 🤔'
      : 'Sorry, we didn’t anticipate this problem 🤔';
  }

  return null;
};

/**
 * Shows error notification and logs an error to Bugsnag
 */
export const logError = (
  error: Error,
  title = 'Error',
  options: {
    isSilent: boolean;
  } = {
    isSilent: false
  }
) => {
  console.error(error);

  if (!options.isSilent) {
    uiLib.showNotification({
      type: uiLib.ALERT_TYPES.ERROR,
      title,
      message: error?.message
    });
  }

  if (env.bugsnagApiKey) {
    Bugsnag.notify(error);
  }
};

export const logReactQueryError = (error: Error) => {
  logError(error, 'Error', {
    isSilent: true
  });
};
